import React, { forwardRef } from 'react';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import { Input } from './';

import 'react-datepicker/dist/react-datepicker.css';
import './DateInputStyle.css';
import { Box } from '@material-ui/core';

const StyleInput = styled(Input)`
  border: 1px solid ${(props) => props.theme.colors.lightGrey};
  border-radius: 5px;
  width: ${(props) => props.width || '100%'};
  height: 33px;

  font-style: italic;
  font-size: 13px;
  font-weight: 300;
  letter-spacing: -0.05em;
  color: ${(props) => props.theme.colors.textPrimary};

  &::placeholder {
    color: ${(props) => props.theme.colors.textPrimary};
  }
`;

const CustomInput = forwardRef(({ value, onClick, disabled }, ref) => {
  return <StyleInput value={value} onClick={onClick} disabled={disabled} />;
});

export const DateInput = ({ width, value, onChange, disabled }) => {
  return (
    <Box width={width || '100%'}>
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat={'dd/MM/yyyy'}
        customInput={<CustomInput />}
        disabled={disabled}
      />
    </Box>
  );
};
